export default [{
    path: "/qspiStockRecovery",
    name: "stockRecoveryPage",
    component: () =>
      import("@/components/page/QSPI/StockRecovery/index"),
    meta: {
      title: "Stock Recovery"
    },
  },
  {
    path: "/qspiStockRecovery/detail",
    name: "stockRecoveryPageDetail",
    component: () =>
      import("@/components/page/QSPI/StockRecovery/detail"),
    meta: {
      title: "Stock Recovery 维护"
    },
  },
  {
    path: "/qspiStockRecovery/view",
    name: "stockRecoveryPageDetail",
    component: () =>
      import("@/components/page/QSPI/StockRecovery/view"),
    meta: {
      title: "Stock Recovery 查看"
    },
  },
  {
    path: "/qualityDefect",
    name: "qualityDefect",
    component: () =>
      import("@/components/page/QSPI/ActiveDisposal/index"),
    meta: {
      title: "主动报废"
    },
  },
  {
    path: "/qualityDefect/detail",
    name: "qualityDefectDetail",
    component: () =>
      import("@/components/page/QSPI/ActiveDisposal/detail"),
    meta: {
      title: "主动报废维护"
    },
  },
  {
    path: "/qualityDefect/view",
    name: "qualityDefectView",
    component: () =>
      import("@/components/page/QSPI/ActiveDisposal/view"),
    meta: {
      title: "主动报废查看"
    },
  },
];